import script from "./PostDetailView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostDetailView.vue?vue&type=script&setup=true&lang=ts"

import "./PostDetailView.vue?vue&type=style&index=0&id=f02b5c86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f02b5c86"]])

export default __exports__